import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const addAssetAdapter = createEntityAdapter({})
const initialState = addAssetAdapter.getInitialState()
export const addAssetApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAssets: builder.query({
            query: () => ({
                url: '/addasset',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedAddAssets = responseData.map(addAsset => {
                    // console.log(addAsset)
                    addAsset.id = addAsset._id
                    // console.log(addAsset)
                    return addAsset
                });
                return addAssetAdapter.setAll(initialState, loadedAddAssets)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'AddAsset', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'AddAsset', id }))
                    ]
                } else return [{ type: 'AddAsset', id: 'LIST' }]
            }
        }),
        getForm13CompAssets: builder.query({
            query: () => ({
                url: '/addasset/compiledform13',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedAddAssets = responseData.map(addAsset => {
                    // console.log(addAsset)
                    addAsset.id = addAsset._id
                    // console.log(addAsset)
                    return addAsset
                });
                return addAssetAdapter.setAll(initialState, loadedAddAssets)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'AddAsset', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'AddAsset', id }))
                    ]
                } else return [{ type: 'AddAsset', id: 'LIST' }]
            }
        }),
        addNewAsset: builder.mutation({
            query: initialUserData => ({
                url: '/addAsset',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'AddAsset', id: "LIST" }
            ]
        }),
        updateAddAsset: builder.mutation({
            query: initialUserData => ({
                url: '/addAsset',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AddAsset', id: arg.id }
            ]
        }),
        deleteAsset: builder.mutation({
            query: ({ id }) => ({
                url: "/addAsset",
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AddAsset', id: arg.id }
            ]
        }),
        updateAddAssetStatus: builder.mutation({
            query: initialUserData => ({
                url: '/addasset/updatestatus',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AddAsset', id: arg.id }
            ]
        }),
        updateflowAddAsset: builder.mutation({
            query: initialUserData => ({
                url: '/addasset/updateflow',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AddAsset', id: arg.id }
            ]
        }),
        editAddAsset: builder.mutation({
            query: initialUserData => ({
                url: '/addasset/edit',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AddAsset', id: arg.id }
            ]
        }),
        editAssettags: builder.mutation({
            query: initialUserData => ({
                url: '/addasset/editassettags',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AddAsset', id: arg.id },
                { type: 'AddAssetFinal', id: 'LIST' },
            ]
        }),
        validatetags: builder.mutation({
            query: initialUserData => ({
                url: '/addasset/validatetags',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AddAsset', id: arg.id }
            ]
        }),
        // Mutation to delete multiple assets
        deleteMultiAssets: builder.mutation({
        query: ({ array }) => ({
            url: "/addasset/deletemultiple",
            method: 'DELETE',
            body: { array }, // Sending array of IDs
        }),
        invalidatesTags: (result, error, arg) => [
            { type: 'AddAsset', id: 'LIST' },
            ...arg.array.map(id => ({ type: 'AddAsset', id })),
        ],
    }),
        // Mutation to check if assets match given criteria
        checkAssetMatch: builder.mutation({
            query: (searchCriteria) => ({
                url: '/addasset/checkmatch',
                method: 'POST',
                body: {
                    ...searchCriteria,
                }
            }),
            // No cache invalidation needed since this is just a check operation
        }),
    }),
})


export const {
    useGetAssetsQuery,
    useGetForm13CompAssetsQuery,
    useAddNewAssetMutation,
    useUpdateAddAssetMutation,
    useDeleteAssetMutation,
    useUpdateAddAssetStatusMutation,
    useUpdateflowAddAssetMutation,
    useEditAddAssetMutation,
    useEditAssettagsMutation,
    useValidatetagsMutation,
    useDeleteMultiAssetsMutation,
    useCheckAssetMatchMutation,
} = addAssetApiSlice

// returns the query result object
export const selectAddAssetsResult = addAssetApiSlice.endpoints.getAssets.select()

// creates memoized selector
const selectAddAssetsData = createSelector(
    selectAddAssetsResult,
    addAssetsResult => addAssetsResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllAddAssets,
    selectById: selectAddAssetById,
    selectIds: selectAddAssetIds
    // Pass in a selector that returns the users slice of state
} = addAssetAdapter.getSelectors(state => selectAddAssetsData(state) ?? initialState)